import apiClient from '../config/api';
import { getWorkshopId } from '../config/constants';

const resolveWorkshopId = (workshopId) => {
    const effectiveWorkshopId = workshopId || getWorkshopId();

    if (!effectiveWorkshopId) {
        throw new Error('Taller no seleccionado');
    }

    return effectiveWorkshopId;
};

export const supplierService = {
    async getSuppliers(workshopId) {
        const resolvedWorkshopId = resolveWorkshopId(workshopId);
        const response = await apiClient.get(`/${resolvedWorkshopId}/suppliers`);
        return response.data;
    },

    async getSupplierById(supplierId, workshopId) {
        const resolvedWorkshopId = resolveWorkshopId(workshopId);
        const response = await apiClient.get(`/${resolvedWorkshopId}/supplier/${supplierId}`);
        return response.data;
    },

    async createSupplier(supplierData, workshopId) {
        const resolvedWorkshopId = resolveWorkshopId(workshopId);
        const payload = {
            name: supplierData.name || '',
            manager_name: supplierData.manager_name || '',
            address: supplierData.address || '',
            phone: supplierData.phone || '',
            RFC: supplierData.RFC || '',
            secondary_phone: supplierData.secondary_phone || null,
            email: supplierData.email || '',
        };

        const response = await apiClient.post(`/${resolvedWorkshopId}/supplier`,
            { data: payload });
        return response.data;
    },

    async updateSupplier(supplierId, supplierData, workshopId) {
        if (!supplierId) {
            throw new Error('Proveedor no seleccionado');
        }

        const resolvedWorkshopId = resolveWorkshopId(workshopId);
        const payload = {
            name: supplierData.name || '',
            manager_name: supplierData.manager_name || '',
            address: supplierData.address || '',
            phone: supplierData.phone || '',
            RFC: supplierData.RFC || '',
            secondary_phone: supplierData.secondary_phone || null,
            email: supplierData.email || '',
        };

        const response = await apiClient.put(`/${resolvedWorkshopId}/supplier/${supplierId}`, 
            { data: payload });
        return response.data;
    },

    async deleteSupplier(supplierId, workshopId) {
        if (!supplierId) {
            throw new Error('Proveedor no seleccionado');
        }

        const resolvedWorkshopId = resolveWorkshopId(workshopId);
        const response = await apiClient.delete(`/${resolvedWorkshopId}/supplier/${supplierId}`);
        return response.data;
    },
};
